import { render } from "./CheckboxItem.vue?vue&type=template&id=745d142e"
import script from "./CheckboxItem.vue?vue&type=script&lang=js"
export * from "./CheckboxItem.vue?vue&type=script&lang=js"

import "./CheckboxItem.vue?vue&type=style&index=0&id=745d142e&lang=scss"

import exportComponent from "/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__